export default __webpack_public_path__ + "static/media/P940_23A940H.5aebf69c.STEP";